module.exports = __webpack_public_path__ + "img/规则定义统计.04d5734a.svg";